export const GLOBAL_STATE = 'CourseTransfer'

export const COURSE_TRANSFER = 'COURSE_TRANSFER' as const
export const COURSE_TRANSFER_LIST = 'COURSE_TRANSFER_LIST' as const
export const COURSE_TRANSFER_INFO = 'COURSE_TRANSFER_INFO' as const
export const COURSE_TRANSFER_COURSES = 'COURSE_TRANSFER_COURSES' as const
